import { useState } from 'react';

export const useWhiteboardEraser = (setTool, setPenType) => {
  const [eraserSize] = useState(20);
  const [eraserTrail, setEraserTrail] = useState([]);
  const [isErasing, setIsErasing] = useState(false);
  const [eraserShadow, setEraserShadow] = useState([]);
  const [fadedShapes, setFadedShapes] = useState(new Set());
  // eslint-disable-next-line no-unused-vars
  const [eraserPreview, setEraserPreview] = useState(null);

  const handleEraserClick = () => {
    setTool('eraser');
    setPenType('eraser');
  };

  return {
    eraserSize,
    eraserTrail, setEraserTrail,
    isErasing, setIsErasing,
    eraserShadow, setEraserShadow,
    fadedShapes, setFadedShapes,
    eraserPreview, setEraserPreview,
    handleEraserClick,
  };
};
